var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 10.8333H14.1665C14.3875 10.8333 14.5995 10.7455 14.7558 10.5892C14.912 10.4329 14.9998 10.221 14.9998 9.99996C14.9998 9.77895 14.912 9.56698 14.7558 9.4107C14.5995 9.25442 14.3875 9.16663 14.1665 9.16663H10.8332V5.83329C10.8332 5.61228 10.7454 5.40032 10.5891 5.24404C10.4328 5.08776 10.2209 4.99996 9.99984 4.99996C9.77882 4.99996 9.56686 5.08776 9.41058 5.24404C9.2543 5.40032 9.1665 5.61228 9.1665 5.83329V9.16663H5.83317C5.61216 9.16663 5.4002 9.25442 5.24392 9.4107C5.08764 9.56698 4.99984 9.77895 4.99984 9.99996C4.99984 10.221 5.08764 10.4329 5.24392 10.5892C5.4002 10.7455 5.61216 10.8333 5.83317 10.8333H9.1665V14.1666C9.1665 14.3876 9.2543 14.5996 9.41058 14.7559C9.56686 14.9122 9.77882 15 9.99984 15C10.2209 15 10.4328 14.9122 10.5891 14.7559C10.7454 14.5996 10.8332 14.3876 10.8332 14.1666V10.8333ZM9.99984 18.3333C5.39734 18.3333 1.6665 14.6025 1.6665 9.99996C1.6665 5.39746 5.39734 1.66663 9.99984 1.66663C14.6023 1.66663 18.3332 5.39746 18.3332 9.99996C18.3332 14.6025 14.6023 18.3333 9.99984 18.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFull);
export default __webpack_public_path__ + "static/media/add_full.c5bae0f4687fbb111da33cb651d72a85.svg";
export { ForwardRef as ReactComponent };